module.exports = __webpack_public_path__ + "img/accepted.2bf21604.svg";